import React from 'react';

import { FontSize, FontWeights } from 'pkg/config/fonts';

import { cssClasses, type CSSPropertiesWithVar } from 'pkg/css/utils';

import * as css from './styles.css';

export interface BaseTextWrapperProps {
	text: string;
	ellipsis?: boolean;
	lines?: number; // Number of lines to clamp if ellipsis is enabled
}

interface TextWrapperProps extends BaseTextWrapperProps {
	fontSize?: FontSize;
	fontWeight?: FontWeights;
	color?: string;
	textTransform?: 'uppercase' | 'lowercase' | 'capitalize' | 'none'; // Text transformation options
	className?: string; // Additional class names for styling
}

export const TextWrapper: React.FC<TextWrapperProps> = ({
	text,
	ellipsis = false,
	lines = 1,
	fontSize = FontSize.base,
	color,
	fontWeight = FontWeights.Normal,
	textTransform = 'none',
	className,
}) => {
	if (text === '' || text === undefined) {
		return null;
	}

	// Ensure that the number of lines is a positive integer
	const validLines = ellipsis && lines > 0 ? lines : 1;

	const styles: CSSPropertiesWithVar = validLines && {
		'--line-clamp': validLines,
		'--selected-font-weight': fontWeight,
		'--selected-font-size': fontSize,
		'--selected-text-transform': textTransform,
		'--selected-text-color': color,
	};

	return (
		<span
			className={cssClasses(
				css.textWrapper,
				ellipsis ? css.ellipsis : '',
				className
			)}
			style={styles}
			data-testid={ellipsis ? 'text-wrapper-ellipsis' : 'text-wrapper'}>
			{text}
		</span>
	);
};
